import { render, staticRenderFns } from "./DeletarRede.vue?vue&type=template&id=cc2e0b12&"
import script from "./DeletarRede.vue?vue&type=script&lang=js&"
export * from "./DeletarRede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports